import React, { memo, useEffect, useState } from 'react'

import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline';
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline';
import AppFormikInputFieldRadio from 'utlis/helpers/forms/AppFormikInputFieldRadio';
import { getCustomerCities, getCustomerStates } from 'utlis/Apis/Customers_API';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { toast } from 'react-toastify';

function FormPurchaseOrdersShippingAddress(props) {
    const { formik, countries, isDisabled } = props
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])
    useEffect(() => {
        const { shipping_country, shipping_state } = formik.values || {}
        if (shipping_country) {
            getStates_(shipping_country)
        }
        if (shipping_state) {
            getCities_(shipping_state)
        }
    }, [formik.values.shipping_country])
    const getStates_ = (country_id) => {
        setStates([])
        setCities([])
        getCustomerStates(country_id).then(res => {
            const stateData = res.data
            if (stateData.success) {
                setStates(stateData.data)
            }

            if (stateData.error) {
                console.log('Error occured while loading states!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getStates `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    const getCities_ = (region_id) => {
        setCities([])
        getCustomerCities(region_id).then(res => {
            const cityData = res.data
            if (cityData.success) {
                setCities(cityData.data)
            }

            if (cityData.error) {
                console.log('Error occured while loading cities!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCities `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
            })
        })
    }

    return (
        <React.Fragment>
            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"First Name"}
                isRequired={true}
                placeholder={"First Name"}
                formikFieldName={"shipping_first_name"}
                isDisabled={isDisabled}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Middle Name"}
                isRequired={false}
                placeholder={"Middle Name"}
                formikFieldName={"shipping_middle_name"}
                isDisabled={isDisabled}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Last Name"}
                isRequired={true}
                placeholder={"Last Name"}
                formikFieldName={"shipping_last_name"}
                isDisabled={isDisabled}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Company Name"}
                isRequired={true}
                placeholder={"Company Name"}
                formikFieldName={"shipping_company_name"}
                isDisabled={isDisabled}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center no-arrows mb-1"}
                labelName={"Mobile Number"}
                isRequired={true}
                inputType={"phone"}
                placeholder={"Mobile Number"}
                formikFieldName={"shipping_mobile"}
                isDisabled={isDisabled}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Street Address"}
                isRequired={true}
                placeholder={"Street Address 1"}
                formikFieldName={"shipping_address"}
                isDisabled={isDisabled}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={" "}
                placeholder={"Street Address 2"}
                formikFieldName={"shipping_address1"}
                isDisabled={isDisabled}
            />

            <AppFormikSelectInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Country"}
                isRequired={true}
                formikFieldName={"shipping_country"}
                onChange={(country) => {
                    getStates_(country)
                    formik.setFieldValue("shipping_state", "")
                    formik.setFieldValue("shipping_city", "")
                    formik.setFieldValue("country", (countries.find(e => e.country_id === parseInt(country)) || {}).country)
                }}
                disabled={isDisabled || countries.length === 0}
                isDisabled={isDisabled}
            >
                <option value="">Select Country</option>
                {(countries && countries.length) && countries.map(item => (
                    <option
                        key={item.country_id.toString()}
                        value={item.country_id.toString()}>{item.country}</option>
                ))
                }
            </AppFormikSelectInline>

            <AppFormikSelectInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"State"}
                isRequired={true}
                formikFieldName={"shipping_state"}
                onChange={(state) => {
                    getCities_(state)
                    formik.setFieldValue("shipping_city", "")
                    formik.setFieldValue("state", (states.find(e => e.region_id === parseInt(state)) || {}).region)
                }}
                disabled={states.length === 0}
                isDisabled={isDisabled}
            >
                <option value="">Select State</option>
                {(states && states.length) && states.map(item => (
                    <option
                        key={item.region_id.toString()}
                        value={item.region_id.toString()}>{item.region}</option>
                ))
                }
            </AppFormikSelectInline>

            <AppFormikSelectInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"City"}
                isRequired={true}
                formikFieldName={"shipping_city"}
                disabled={cities.length === 0}
                isDisabled={isDisabled}
                onChange={(city) => {
                    formik.setFieldValue("city", (cities.find(e => e.city_id === parseInt(city)) || {}).city)
                }}
            >
                <option value="">Select City</option>
                {(cities && cities.length) && cities.map(item => (
                    <option
                        key={item.city_id.toString()}
                        value={item.city_id.toString()}>{item.city}</option>
                ))
                }
            </AppFormikSelectInline>

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Zip/Postal Code"}
                isRequired={false}
                placeholder={"Zip/Postal Code"}
                formikFieldName={"shipping_zipcode"}
                isDisabled={isDisabled}
            />
            <div style={{ paddingLeft: '180px' }}>
                <AppFormikInputFieldRadio
                    formik={formik}
                    stFormClass={"st-form st-form-with-label-left d-flex flex-wrap align-items-center"}
                    formikFieldName={"saveToVendorAddressBook"}
                    labelNameRight={"Save to vendor's address book"}
                />
            </div>

        </React.Fragment >
    )
}

export default memo(FormPurchaseOrdersShippingAddress)